import { RFQStatesType } from "./materialContext";
import { Actions } from "./types";

export enum rfqStatesType {
  MRF = "MRF",
  SET_ITEM_ID = "SET_ITEM_ID",
  SUPPLIERS = "SUPPLIERS",
}
export const reducer = (state: RFQStatesType, action: Actions) => {
  switch (action.type) {
    case rfqStatesType.MRF:
      return {
        ...state,
        mrf: action.payload.mrf,
      };
    case rfqStatesType.SET_ITEM_ID:
      return {
        ...state,
        itm: action.payload.itm,
      };
    case rfqStatesType.SUPPLIERS:
      return {
        ...state,
        selectedSuppliers: action.payload.selectedSuppliers,
      };
    default:
      return state;
  }
};
